<template>
    <div id="relatorio-financeiro">
        <div class="title d-flex justify-content-center mb-5">
            <h2 v-if="receberTab">Relatório de Contas a Pagar Agrupado por Cliente</h2>
            <h2 v-if="pagarTab">Relatório de Contas a Pagar Agrupado por Fornecedor</h2>
        </div>
        <div class="d-flex flex-column align-items-start">
            <div class="d-flex justify-content-between align-items-center w-100">
                <div class="d-flex flex-column align-items-start text-start gap-10" >
                    <div class="d-flex flex-column align-items-start gap-10" >
                        <span class="" v-if="finListGrupo[0].codpart && !finListGrupo[0].codfin"><strong>Cliente: </strong> {{finListGrupo[0].nome}}
                        <strong class="ml-3" v-if="periodo.startDate && periodo.endDate">Periodo : </strong> {{ periodo.startDate | formatData }} à {{ periodo.endDate | formatData }} </span>
                        <span v-if="valor.start || valor.end"><strong>Valor de:</strong> {{valor.start | formatValue(2)}} <strong class="ml-1">Valor até:</strong> {{valor.end | formatValue(2)}}</span>
                        <span v-if="documento.start || documento.end"><strong>Doc. de: </strong> {{documento.start}} <strong class="ml-2" >Doc até: </strong>{{documento.end}}</span>
                    </div>
                    <div class="d-flex flex-row align-items-start gap-10">
                        <span v-if="periodoEmissao.startDate || periodoEmissao.endDate" class=""><strong>Periodo Emissão: </strong>{{periodoEmissao.startDate | formatDate}} a {{periodoEmissao.endDate}}</span>
                        <span v-if="periodoVencimento.startDate || periodoVencimento.endDate" class=""><strong>Periodo Vencimento: </strong>{{periodoVencimento.startDate | formatDate}} a {{periodoVencimento.endDate}}</span>
                        <span v-if="periodoRecebimento.startDate || periodoRecebimento.endDate" class=""><strong>Periodo Recebimento: </strong>{{periodoRecebimento.startDate | formatDate}} a {{periodoRecebimento.endDate}}</span>
                    </div>
                </div>
                <div class="d-flex align-items-center">
                    <strong style="font-size: 1rem; font-weight: 600;"> {{companyName}} </strong>
                </div>
            </div>

            <table class="table table-borderless table-sm">
                <thead>
                    <tr class="border-bottom border-dark">
                        <th scope="col" class="span-header">Histórico</th>
                        <th scope="col" class="span-header text-center">Nro. documento</th>
                        <th scope="col" class="span-header text-center">Vencimento</th>
                        <th scope="col" class="span-header text-center">Liquidação</th>
                        <th scope="col" class="span-header text-center">Situação</th>
                        <th scope="col" class="span-header text-center">Pago</th>
                    </tr>
                </thead>
                <tbody>
                    <hr class="mt-5">
                    <template v-for="(fin, index) in finListGrupo">
                        <tr class="border-bottom border-dark" v-if="fin.codpart && !fin.codfin" :key="index">
                            <th scope="row" colspan="6"><span class="span-title font-weight-bold">{{ fin.nome }}</span></th>
                        </tr>
                        <tr class="border-bottom border-dark" v-if="fin.codfin" :key="index">
                            <th scope="row">{{ fin.natureza }}</th>
                            <td class="text-center">{{ fin.doc }}</td>
                            <td class="text-center">{{ fin.vencimento | formatData }}</td>
                            <td class="text-center">{{ fin.dataBaixa | formatData }}</td>
                            <td class="text-center" v-if="fin.baixado">Pago</td>
                            <td class="text-center" v-if="fin.aberto">Em Aberto</td>
                            <td class="text-center">{{ fin.vlr | formatValue(2, true) }}</td>                                
                        </tr>
                        <tr  v-if="fin.total" :key="index">
                            <th scope="row" colspan="5" class="span-header text-right font-weight-bold">Total: </th>
                            <th scope="row" colspan="6" class="span-header text-right font-weight-bold">R$ {{ fin.total | formatValue(2)}}</th>
                        </tr>
                        <tr  v-if="fin.totalGeral" :key="index">
                            <th scope="row" colspan="5" class="span-header text-right font-weight-bold">Total Geral: </th>
                            <th scope="row" colspan="6" class="span-header text-right font-weight-bold">R$ {{ fin.totalGeral | formatValue(2)}}</th>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    props: [ 'companyName', 'finListGrupo', 'receberTab', 'pagarTab', 'codpart', 'valor', 'documento', 'periodo', 'periodoEmissao', 'periodoVencimento', 'periodoRecebimento' ],

    methods: {
        handleAfterPrint(window){

            window.addEventListener('afterprint', () => {
                window.close();
            })

        },
        relatorio (prtHtml) {

            // const prtHtml = document.getElementById('relatorio').innerHTML

            let stylesHtml = '';
            for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
                stylesHtml += node.outerHTML;
            }
            const WinPrint = window.open('', '_blank' );

            WinPrint.document.write(`
                <!DOCTYPE html>
                <html>
                    <head>
                        ${stylesHtml}
                    </head>
                    <body>
                        <div>
                            <div class="w-100 p-3">
                                ${prtHtml}
                            </div>
                        </div>
                    </body>
                </html>
            `);

            WinPrint.document.close();
            WinPrint.focus();
            
            this.handleAfterPrint(WinPrint);
            
            // WinPrint.print();
            // WinPrint.close();
            
            this.$emit('close');
        },
    },

    mounted () {
        let vm = this
        setTimeout(() => {
            const prtHtml = document.getElementById('relatorio-financeiro').innerHTML
            vm.relatorio(prtHtml)
        }, 1000);
    },

    created () {

    },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/forms/financeiro-relatorio-agrupado.vue